/* -disable consistent-return */
import moment from 'moment';
import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions
const GET_MANIFEST = 'luft/on-time/GET_MANIFEST';
const GET_MANIFEST_SUCCESS = 'luft/on-time/GET_MANIFEST_SUCCESS';
const GET_MANIFEST_FAILURE = 'luft/on-time/GET_MANIFEST_FAILURE';

// reducer
const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  currentManifest: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_MANIFEST:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
        list: null,
      };

    case GET_MANIFEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list,
      };

    case GET_MANIFEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators
function _getManifest() {
  return { type: GET_MANIFEST };
}

function _getManifestSuccess(list) {
  return {
    type: GET_MANIFEST_SUCCESS,
    list,
  };
}

function _getManifestFailure(error) {
  return {
    type: GET_MANIFEST_FAILURE,
    error,
  };
}

// thunk action creators
export function getManifest(params) {
  return async function (dispatch) {
    return (async () => {
      dispatch(_getManifest());

      try {
        const response = await luftGet('/OnTime/GetManifest', params);
        dispatch(_getManifestSuccess(response.data));
        return response.data;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getManifestFailure(error.message),
        );
      }
    })();
  };
}
